module.exports = __webpack_public_path__ + "static/media/genes-therapy.15fcdba2.svg";